import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { Gear, Pin, Plus } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";
import { ApiConnectionString } from "../../constants/ApiConntection";
import axios from "axios";
import { useAuthContext } from "../../hooks/useAuthContext";
import DeletePostModal from "./modals/DeletePostModal";
import PinPostModal from "./modals/PinPostModal";
import UnPinPostModal from "./modals/UnPinPostModal";
import LoadingSpinner from "../../components/LoadingSpinner";

import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import { LightGalleryKeyString } from "../../constants/LightGalleryKey";

export default function Posts({ id }) {
  const [noMorePosts, setNoMorePosts] = useState(false);
  const [pinnedClubPost, setPinnedClubPost] = useState(null);
  const [skip, setSkip] = useState(0);
  const [take, setTake] = useState(10);
  const [clubPosts, setClubPosts] = useState([]);
  const [selectedPost, setSelectedPost] = useState(null);
  const [deletePostModal, setDeletePostModal] = useState(false);
  const [pinPostModal, setPinPostModal] = useState(false);
  const [unPinPostModal, setUnPinPostModal] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const { user, dispatch } = useAuthContext();
  const navi = useNavigate();

  const cancelModal = () => {
    setDeletePostModal(false);
    setPinPostModal(false);
    setUnPinPostModal(false);
  };

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const pinnedClubPostResponse = await axios.get(
        `${ApiConnectionString}/api/ClubPost/pin/${id}`
      );
      setPinnedClubPost(pinnedClubPostResponse.data);

      const clubPostsResponse = await axios.get(
        `${ApiConnectionString}/api/ClubPosts?Skip=0&Take=10&ClubId=${id}`
      );
      setClubPosts(clubPostsResponse.data);
    } catch (error) {
      if (error.status == 401) {
        dispatch({ type: "LOGOUT" });
        navi("/");
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    let timeout;

    if (user) {
      fetchData();
    } else {
      timeout = setTimeout(() => {
        dispatch({ type: "LOGOUT" });
        navi("/");
      }, 3000);
    }

    return () => clearTimeout(timeout);
  }, [id, user]);

  const ViewMorePosts = async () => {
    const newSkip = skip + 10;
    const newTake = take + 10;

    const clubPostsResponse = await axios.get(
      `${ApiConnectionString}/api/ClubPosts?Skip=${newSkip}&Take=${newTake}&ClubId=${id}`
    );

    if (clubPostsResponse.data.length === 0) {
      setNoMorePosts(true);
    }

    setClubPosts((prevPosts) => [...prevPosts, ...clubPostsResponse.data]);
    setSkip(newSkip);
    setTake(newTake);
  };

const renderImages = (images) => (
  <LightGallery licenseKey={LightGalleryKeyString} elementClassNames="d-flex">
    {images.map((image, index) => {
      const isVisible = index < 3;
      const showOverlay = index === 2 && images.length > 3;

      return (
        <a
          href={`${ApiConnectionString}/api/image/${image.id}`}
          key={image.id}
          className={`post-image-container image-container pointer ${showOverlay ? "with-overlay" : ""}`}
          style={{ display: isVisible ? 'block' : 'none' }}
        >
          {isVisible && (
            <>
              <img
                className="post-image"
                src={`${ApiConnectionString}/api/image/${image.id}`}
                alt={`Image ${image.id}`}
              />
              {showOverlay && (
                <div className="post-overlay d-flex align-items-center justify-content-center fw-bold text-white">
                  +{images.length - 3}
                </div>
              )}
            </>
          )}
        </a>
      );
    })}
  </LightGallery>
);


  if (isLoading) {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <div>
      <div className="lightBlueBanner">
        <p className="fw-bold p-2">Club Posts</p>
      </div>

      <button
        className="profile-blue-button mb-2 d-flex"
        onClick={() => navi(`/CreatePost/${id}`)}
      >
        <Plus className="profile-social-icon" />
        <a className="fw-bold mx-2 mt-1">Create a new post</a>
      </button>

      <div className="row">
        <div className="col-12 text-center">
          {pinnedClubPost && (
            <div className="border">
              <Dropdown>
                <Dropdown.Toggle
                  as="span"
                  id="dropdown-custom-components"
                  className="dropdown-toggle-custom"
                >
                  <Gear
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setSelectedPost(pinnedClubPost);
                    }}
                  />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => setUnPinPostModal(true)}>
                    Un-pin
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => navi(`/editpost/${pinnedClubPost.id}`)}
                  >
                    Edit
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => setDeletePostModal(true)}>
                    Delete
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              <h2>{pinnedClubPost.title}</h2>
              <div className="fw-bold red-text d-flex justify-content-center">
                <p className="mb-0 me-2">Pinned Post</p>
                <Pin />
              </div>
              <p>{pinnedClubPost.content}</p>
              {pinnedClubPost.createdDate && (
                <p>{pinnedClubPost.createdDate.substring(0, 10)}</p>
              )}
              {pinnedClubPost.viewImages.length > 0 &&
                renderImages(pinnedClubPost.viewImages)}
            </div>
          )}

          {clubPosts.length > 0 ? (
            <>
              {clubPosts
                .slice()
                .sort(
                  (a, b) =>
                    new Date(b.createdDate) - new Date(a.createdDate)
                )
                .map((post) => (
                  <div key={post.id} className="border">
                    <Dropdown>
                      <Dropdown.Toggle
                        as="span"
                        id="dropdown-custom-components"
                        className="dropdown-toggle-custom"
                      >
                        <Gear
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setSelectedPost(post);
                          }}
                        />
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item onClick={() => setPinPostModal(true)}>
                          Pin this post
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() => navi(`/editpost/${post.id}`)}
                        >
                          Edit
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => setDeletePostModal(true)}>
                          Delete
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                    <h2>{post.title}</h2>
                    <p>{post.content}</p>
                    {post.createdDate && (
                      <p>{post.createdDate.substring(0, 10)}</p>
                    )}
                    {post.viewImages.length > 0 && renderImages(post.viewImages)}
                  </div>
                ))}
              {!noMorePosts ? (
                <button
                  className="moc-red-button my-3"
                  onClick={ViewMorePosts}
                  disabled={noMorePosts}
                >
                  <a className="fw-bold">View more</a>
                </button>
              ) : (
                <p>No more posts</p>
              )}
            </>
          ) : (
            <div>
              <p className="text-muted">Currently, there are no posts</p>
            </div>
          )}
        </div>

        {deletePostModal && (
          <DeletePostModal
            post={selectedPost}
            cancelModal={cancelModal}
            fetchData={fetchData}
          />
        )}
        {pinPostModal && (
          <PinPostModal
            post={selectedPost}
            cancelModal={cancelModal}
            fetchData={fetchData}
          />
        )}
        {unPinPostModal && (
          <UnPinPostModal
            post={selectedPost}
            cancelModal={cancelModal}
            fetchData={fetchData}
          />
        )}
      </div>
    </div>
  );
}
